import constants from '../constants';
export const setupGondolinBridges = () => {
    const GlanceBridges = Object.keys(window.GlanceAndroidInterface);
    const NativeBridges = GlanceBridges.filter((key) => constants.GONDOLIN_BRIDGE.indexOf(key) < 0);
    NativeBridges.forEach((bridgeFunction) => {
        // @ts-expect-error since args can be never as well, TS will complain
        window.Gondolin[bridgeFunction] = (...args) => {
            // @ts-expect-error since args can be never as well, TS will complain
            return window.GlanceAndroidInterface[bridgeFunction](...args);
        };
    });
};
//# sourceMappingURL=gondolinbridge.js.map